import { ProfileColor } from "../../../ProfileColor";
import { DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagerProfile extends Layout {
    layoutProfileColor: ProfileColor;
    sourceDriverManagerProfile: DataSource;
    switchSwitchNoMgr: Switch;
    textboxActiveStatus1: Textbox;
    textboxDriverManagers: Textbox;
    textboxId: Textbox;
}
